import React from 'react';

interface AlignmentControlProps {
  value: number; // Angle value (-90 to 90)
  onChange: (degrees: number) => void;
  disabled?: boolean;
}

const AlignmentControl: React.FC<AlignmentControlProps> = ({ value, onChange, disabled = false }) => {
  // Map angle to option - only 45° (diagonal) and -45° (negative diagonal)
  const getOptionFromAngle = (angle: number): string => {
    if (angle === 45) return 'diagonal';
    if (angle === -45) return 'negative-diagonal';
    // Default to 45° if angle doesn't match
    return 'diagonal';
  };

  const currentOption = getOptionFromAngle(value);

  const handleAngleClick = (angle: number) => {
    if (!disabled) {
      onChange(angle);
    }
  };

  return (
    <div className="flex items-center gap-2">
      {/* Diagonal (45°) - bottom-left to top-right (/) */}
      <button
        type="button"
        onClick={() => handleAngleClick(45)}
        disabled={disabled}
        className={`w-10 h-10 border-2 rounded-lg flex items-center justify-center transition-all relative overflow-hidden ${
          currentOption === 'diagonal'
            ? 'border-governate-600 dark:border-governate-400 bg-governate-600 dark:bg-governate-500'
            : 'border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 hover:border-gray-400 dark:hover:border-gray-500'
        } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
        title="Diagonal (45°)"
      >
        <div 
          className="w-full h-full absolute inset-0"
          style={{
            backgroundImage: `repeating-linear-gradient(
              135deg,
              ${currentOption === 'diagonal' ? 'rgba(255, 255, 255, 1)' : 'rgba(0, 0, 0, 0.8)'} 0px,
              ${currentOption === 'diagonal' ? 'rgba(255, 255, 255, 1)' : 'rgba(0, 0, 0, 0.8)'} 2px,
              transparent 2px,
              transparent 6px
            )`,
          }}
        />
      </button>

      {/* Negative Diagonal (-45°) - top-left to bottom-right (\\) */}
      <button
        type="button"
        onClick={() => handleAngleClick(-45)}
        disabled={disabled}
        className={`w-10 h-10 border-2 rounded-lg flex items-center justify-center transition-all relative overflow-hidden ${
          currentOption === 'negative-diagonal'
            ? 'border-governate-600 dark:border-governate-400 bg-governate-600 dark:bg-governate-500'
            : 'border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 hover:border-gray-400 dark:hover:border-gray-500'
        } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
        title="Negative Diagonal (-45°)"
      >
            <div
          className="w-full h-full absolute inset-0"
              style={{
            backgroundImage: `repeating-linear-gradient(
              45deg,
              ${currentOption === 'negative-diagonal' ? 'rgba(255, 255, 255, 1)' : 'rgba(0, 0, 0, 0.8)'} 0px,
              ${currentOption === 'negative-diagonal' ? 'rgba(255, 255, 255, 1)' : 'rgba(0, 0, 0, 0.8)'} 2px,
              transparent 2px,
              transparent 6px
            )`,
              }}
            />
      </button>
    </div>
  );
};

export default AlignmentControl;
